"use strict";

import angular from "angular";

const name = "columnSize";
const factory = function columnSizeFilter() {
    return function (column, index) {
        const values = column.split(",");
        const total = values.reduce((r, v) => r + parseInt(v, 10), 0);
        const sizes = values.map((v) =>
            Math.floor((100 / total) * parseInt(v, 10))
        );
        return sizes[index] || sizes;
    };
};
angular.module("nucont.shared").filter(name, factory);
export default { name, factory };
